import * as React from 'react';

function Flame(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M5.678 15.627C6.68 18.85 11.102 21 11.102 21s-.957-2.066-.943-3.492c.017-1.833 1.65-4.299 1.65-4.299s1.573 2.468 1.651 4.299c.06 1.398-.707 3.492-.707 3.492s5.353-2.955 5.66-5.373c.307-2.418-4.01-7.791-4.01-7.791s.434 2.853 0 4.567C13.444 16.203 11.103 3 11.103 3s-6.428 9.403-5.424 12.627z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Flame;
